
















































import { Component, Vue } from 'vue-property-decorator';
import AppLogo from './AppLogo.vue';
import VueCookies from 'vue-cookies';
import AES from 'crypto-js/aes'
import SHA256 from 'crypto-js/sha256'
import CryptoJS from 'crypto-js';
import Browserwarning from '../components/Browser_warning modal.vue'

@Component({
    components: {
        AppLogo,Browserwarning
    },
  mounted: function() {
  let userAgentString = navigator.userAgent;
  let browserName;
     if(!(userAgentString.indexOf("Chrome") > -1)){
         browserName = "chrome";
         this.$data.browser_warning=true;
       }
},
})
export default class Login extends Vue {

    
data() {
        return {
            username: '',
            password: '',
            account_name: '',
            showErrorMessage: false,
            usernameError: false,
            passwordError: false,
            accountError: false,
            isLoading: false,
            remember_me: false,
            browser_warning:false
        }
    }
    created() {
        if((this as any).$route.query.creds && (this as any).$route.query.account_name) {
            this.$store.dispatch('relogin', {
                creds: (this as any).$route.query.creds,
                account_name: (this as any).$route.query.account_name
            }).then(() => {
                this.$data.isLoading = false;
                (this as any).$router.push({
                    path: '/dashboard',
                    query: {
                        phoneNumber: (this as any).$route.query.phoneNumber
                    }
                });
            }).catch(() => {
                this.$data.isLoading = false;
                this.$data.showErrorMessage = true;
            })
        } else {
            if ((this as any).$cookies.get('username')) {
                this.$data.username = AES.decrypt(decodeURI((this as any).$cookies.get('username')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
            }
            if ((this as any).$cookies.get('password')) {
                 this.$data.password = AES.decrypt(decodeURI((this as any).$cookies.get('password')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
            }
            if ((this as any).$cookies.get('account_name')) {
                 this.$data.account_name = AES.decrypt(decodeURI((this as any).$cookies.get('account_name')),"2r5u8x/A").toString(CryptoJS.enc.Utf8);
            }
           if ((this as any).$cookies.get('remember_me')) {
                this.$data.remember_me = decodeURI((this as any).$cookies.get('remember_me'));
            }
        }
    }

    onSubmit() {
        this.$data.accountError = false;
        this.$data.passwordError = false;
        this.$data.usernameError = false;
        if (!this.$data.username) {
            this.$data.usernameError = true;
        }
        if (!this.$data.password) {
            this.$data.passwordError = true;
        }
        if (!this.$data.account_name) {
            this.$data.accountError = true;
        }
        const {usernameError, passwordError, accountError} = this.$data;
        if (!usernameError && !passwordError && !accountError) {
            this.$data.isLoading = true;

            
            this.$store.dispatch('login', {
                username: this.$data.username.toLowerCase().trim(),
                password: this.$data.password.trim(),
                account_name: this.$data.account_name.toLowerCase().trim()
            }).then((r) => {
                     this.$store.dispatch('getTextPermissions');

                if(this.$data.remember_me) {
                    var uname=AES.encrypt(this.$data.username,"2r5u8x/A").toString();
                    var p= AES.encrypt(this.$data.password,"2r5u8x/A").toString();
                    var a= AES.encrypt(this.$data.account_name,"2r5u8x/A").toString();
                    (this as any).$cookies.set('username',uname , '240h');
                    (this as any).$cookies.set('password',p , '10h');
                    (this as any).$cookies.set('account_name', a, '240h');
                    (this as any).$cookies.set('remember_me', this.$data.remember_me, '240h');
                }
                else{
                   var uname=AES.encrypt(this.$data.username,"2r5u8x/A").toString();
                   (this as any).$cookies.set('username',uname , '240h');
                }
                this.$data.isLoading = false;
                this.$store.dispatch('getPrivilegeLevel');
                (this as any).$router.push('/dashboard')  ;
            }).catch((e) => {
                this.$data.isLoading = false;
                this.$data.showErrorMessage = true;
            })
        }
    }

    closebroweserwarning(){
        this.$data.browser_warning=false;
    }
}
